import { useContext, useMemo } from 'react';
import { CmsContent } from 'src/content';
import { useNewTimedPromotionForClub } from 'src/components/common/promo/use-new-club-timed-promotion';

export const useHeaderPromoRibbonContent = () => {
  const { headerContent } = useContext(CmsContent);

  const { isTimedPromotionReady, timedPromoActiveForCurrentClub, shouldUseHeaderRibbonPromotion } =
    useNewTimedPromotionForClub();

  return useMemo(() => {
    return isTimedPromotionReady && shouldUseHeaderRibbonPromotion
      ? ({
          enabled: true,
          ...timedPromoActiveForCurrentClub?.promotionDetails?.headerPromoRibbon!,
          selectedPages: headerContent?.headerPromoRibbon?.enabled
            ? {
                ...headerContent?.headerPromoRibbon?.selectedPages,
                homePage: true,
              }
            : {
                homePage: true,
              },
        } as Queries.HeaderPromoRibbon)
      : headerContent?.headerPromoRibbon;
  }, [
    headerContent?.headerPromoRibbon,
    isTimedPromotionReady,
    timedPromoActiveForCurrentClub?.promotionDetails?.headerPromoRibbon,
    shouldUseHeaderRibbonPromotion,
  ]);
};
